import { styled, Typography, Box, Button } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import MissingImage from 'components/MissingImage';

export const Title = styled(Typography)``;

export const Description = styled(Typography)`
  margin-bottom: 1rem;
`;

export const Footer = styled(Box)`
  border-radius: ${theme.radius.sm};
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.15);
  margin-top: auto;
  padding: 1rem;
  padding-bottom: 1.5rem;
  user-select: none;
  width: 100%;

  ${theme.breakpoints.up('sm')} {
    border-radius: ${theme.radius.xl};
    padding-bottom: 1rem;
  }
`;

export const PurchaseButton = styled(Button)`
  justify-content: space-between;
`;

export const StyledMissingImage = styled(MissingImage)`
  min-height: 180px;

  ${theme.breakpoints.up('md')} {
    min-height: 260px;
  }
`;
